
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30745',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30745",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55264",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8300",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11756",
  "I18n": "static-7.1668",
  "quartz": "static-1.7416",
  "quartz-config": "static-1.1194",
  "quartz-core": "static-1.6635",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.889",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55251",
  "feedback-utils": "static-1.55255",
  "forms-embed-utils-lib": "static-1.4733",
  "forms-utils-lib": "static-1.13055",
  "foundations-assets": "static-1.5152",
  "foundations-components": "static-1.8442",
  "foundations-theming": "static-1.4743",
  "hub-http": "static-1.6482",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12063",
  "icons": "static-2.677",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4109",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5535",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.500",
  "tinymce-plugins": "static-1.58163",
  "transmute": "static-2.85",
  "ui-images": "static-2.1238",
  "UIComponents": "static-3.8702",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3693",
  "quartz-webpack": "static-1.3640",
  "foundations-theming-specialty": "static-1.2459",
  "property-description-translator": "static-1.4110",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3411",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4583",
  "jasmine-runner": "static-1.6722",
  "opentelemetry-fe-types": "static-1.39",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.874",
  "hubspotter-http": "static-1.4843",
  "mobile-manifest-mixins": "static-1.574",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.414",
  "quartz-auth": "static-1.1091",
  "quartz-head": "static-1.1081",
  "quartz-i18n": "static-1.1091",
  "quartz-routing": "static-1.846",
  "quartz-test": "static-1.1091",
  "quartz-tracking": "static-1.795",
  "trellis-components": "static-1.2573",
  "ui-fonts": "static-1.1018",
  "usage-tracker-container": "static-1.7615",
  "usage-tracker-core": "static-1.7475",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7515",
  "reference-resolvers": "static-1.8451",
  "sanitize-text": "static-1.8422",
  "PatternValidationJS": "static-1.3164",
  "ReduxMessenger": "static-2.10638",
  "outpost": "static-1.4427",
  "rpc-client-utils": "static-1.4934",
  "sanitize": "static-1.4743",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4711",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9695",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.67",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2554",
  "bend-plugin-foundations-theming": "static-1.3226",
  "foundations-theming-base": "static-1.3728",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.272",
  "csstype": "static-1.50",
  "web-vitals": "static-1.12",
  "ai-components-ui-library": "static-1.9656",
  "atom": "static-1.5354",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8160",
  "ContentUtils": "static-1.69071",
  "data-token-picker": "static-1.16846",
  "file-manager-components": "static-1.24422",
  "FileManagerCore": "static-1.39921",
  "FileManagerLib": "static-1.40062",
  "frontend-preferences-client": "static-1.8192",
  "hub-http-contrib": "static-1.3308",
  "interframe": "static-3.5024",
  "layout-dnd-components": "static-1.12922",
  "layout-dnd-utils": "static-1.11897",
  "property-translator": "static-1.5667",
  "react-codemirror": "static-1.10908",
  "react-colorpicker": "static-2.10477",
  "reference-resolvers-lite": "static-1.8372",
  "rich-text-lib": "static-1.20266",
  "tinymce-data": "static-1.41134",
  "tinymce-themes": "static-1.57019",
  "ui-addon-emoji-picker": "static-1.10155",
  "ui-addon-sales-email": "static-1.5482",
  "ui-brand-identity-lib": "static-1.16354",
  "bender-build-tools": "static-1.3411",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10567",
  "hubspotter-http-shared-msw-handlers": "static-1.10565",
  "usage-tracker-session-replay": "static-1.5311",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1238",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.344",
  "chirp-fetch": "static-1.2163",
  "chatspot-core": "static-1.22807",
  "copilot-toolkit": "static-1.11796",
  "customer-data-objects-ui-components": "static-1.13300",
  "data-fetching-client": "static-1.9927",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5026",
  "ui-addon-video-player": "static-1.8971",
  "ui-coaching-tips": "static-1.29255",
  "usage-tracker": "static-1.7625",
  "cms-field-types": "static-1.5084",
  "content-icons-ui": "static-1.2332",
  "integrations-lib": "static-1.16976",
  "customer-data-objects": "static-1.7958",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1642",
  "apollo-link-hub-http": "static-2.4925",
  "apollo-stack-hubspot": "static-3.91",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4419",
  "ui-addon-iframeable": "static-1.9346",
  "video-components-external": "static-1.12102",
  "video-data-lib": "static-1.35760",
  "breeze-artifacts-sdk": "static-1.252",
  "audio-components": "static-1.6301",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29768",
  "FileManagerImages": "static-1.37573",
  "foundations-components-legacy": "static-1.1467",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.532",
  "ui-universal-auth": "static-1.9343",
  "urlinator": "static-1.4802",
  "video-components": "static-1.14104",
  "video-embed": "static-1.36594",
  "ts-schema": "static-1.4272",
  "ContentData": "static-1.69146",
  "layout-data-lib": "static-1.10222",
  "react-dnd-compat": "static-1.4886",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1812",
  "external-options-client-types": "static-1.4318",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7161",
  "hs-promise-utils": "static-1.5866",
  "inbound-db-properties-service-client": "static-1.4035",
  "NamespacedHubStyle": "static-2.9241",
  "growth-onboarding-confetti": "static-1.3331",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11415",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5735",
  "magpie-types": "static-1.5195",
  "simple-logging-lib": "static-1.3320",
  "avatar-components": "static-1.2763",
  "customer-data-ui-utilities": "static-1.10098",
  "growth-onboarding-feedback-components": "static-1.6852",
  "flux-actions": "static-1.365",
  "hubspot-apollo-client": "static-1.5148",
  "integrations-error-boundary-lib": "static-1.14391",
  "integrations-tracking-lib": "static-1.5877",
  "laboratory-lib": "static-3.7420",
  "native-integrations-shared-strings": "static-1.8048",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10536",
  "unified-auth": "static-1.857",
  "breeze-engine-chat-components": "static-1.620",
  "breeze-engine-core": "static-1.920",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8091",
  "content-media-composition-data-lib": "static-1.13179",
  "content-media-compositions": "static-2.17186",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19366",
  "unified-auth-core-lib": "static-1.1139",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15537",
  "advanced-menus-lib": "static-1.12415",
  "ExportDialog": "static-6.10648",
  "ui-memberships-settings-lib": "static-1.34788",
  "conditional-properties-service-client": "static-1.3989",
  "crm-pipelines-api-client-types": "static-1.4326",
  "fdsr-migration-layer": "static-1.280",
  "framework-builder-read-service-client": "static-1.4200",
  "framework-data-schema-quick-fetch": "static-1.7066",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3887",
  "persist-promise": "static-1.3969",
  "foundations-components-test-utils": "static-1.5925",
  "reactive-lib": "static-1.989",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.607",
  "universal-page-editor-lib": "static-1.3277",
  "adobe-sign-auth-lib": "static-1.409",
  "ads-unified-auth-lib": "static-1.1207",
  "google-sheets-integration-lib": "static-1.976",
  "microsoft-drive-auth-lib": "static-1.74",
  "surveymonkey-integration-lib": "static-1.420",
  "slack-ui-library": "static-1.10667",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4017",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15536",
  "simple-menus-lib": "static-1.17053",
  "crm-record-cards-service-types": "static-1.3763",
  "location-customization-utils-lib": "static-1.10043",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30745",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55264",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8300",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11756",
  "I18n": "/I18n/static-7.1668",
  "quartz": "/quartz/static-1.7416",
  "quartz-config": "/quartz-config/static-1.1194",
  "quartz-core": "/quartz-core/static-1.6635",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.889",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55251",
  "feedback-utils": "/feedback-utils/static-1.55255",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4733",
  "forms-utils-lib": "/forms-utils-lib/static-1.13055",
  "foundations-assets": "/foundations-assets/static-1.5152",
  "foundations-components": "/foundations-components/static-1.8442",
  "foundations-theming": "/foundations-theming/static-1.4743",
  "hub-http": "/hub-http/static-1.6482",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12063",
  "icons": "/icons/static-2.677",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5535",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.500",
  "tinymce-plugins": "/tinymce-plugins/static-1.58163",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1238",
  "UIComponents": "/UIComponents/static-3.8702",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3693",
  "quartz-webpack": "/quartz-webpack/static-1.3640",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2459",
  "property-description-translator": "/property-description-translator/static-1.4110",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3411",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4583",
  "jasmine-runner": "/jasmine-runner/static-1.6722",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.39",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.874",
  "hubspotter-http": "/hubspotter-http/static-1.4843",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.414",
  "quartz-auth": "/quartz-auth/static-1.1091",
  "quartz-head": "/quartz-head/static-1.1081",
  "quartz-i18n": "/quartz-i18n/static-1.1091",
  "quartz-routing": "/quartz-routing/static-1.846",
  "quartz-test": "/quartz-test/static-1.1091",
  "quartz-tracking": "/quartz-tracking/static-1.795",
  "trellis-components": "/trellis-components/static-1.2573",
  "ui-fonts": "/ui-fonts/static-1.1018",
  "usage-tracker-container": "/usage-tracker-container/static-1.7615",
  "usage-tracker-core": "/usage-tracker-core/static-1.7475",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7515",
  "reference-resolvers": "/reference-resolvers/static-1.8451",
  "sanitize-text": "/sanitize-text/static-1.8422",
  "PatternValidationJS": "/PatternValidationJS/static-1.3164",
  "ReduxMessenger": "/ReduxMessenger/static-2.10638",
  "outpost": "/outpost/static-1.4427",
  "rpc-client-utils": "/rpc-client-utils/static-1.4934",
  "sanitize": "/sanitize/static-1.4743",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4711",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9695",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2554",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3226",
  "foundations-theming-base": "/foundations-theming-base/static-1.3728",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.272",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.12",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9656",
  "atom": "/atom/static-1.5354",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8160",
  "ContentUtils": "/ContentUtils/static-1.69071",
  "data-token-picker": "/data-token-picker/static-1.16846",
  "file-manager-components": "/file-manager-components/static-1.24422",
  "FileManagerCore": "/FileManagerCore/static-1.39921",
  "FileManagerLib": "/FileManagerLib/static-1.40062",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8192",
  "hub-http-contrib": "/hub-http-contrib/static-1.3308",
  "interframe": "/interframe/static-3.5024",
  "layout-dnd-components": "/layout-dnd-components/static-1.12922",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11897",
  "property-translator": "/property-translator/static-1.5667",
  "react-codemirror": "/react-codemirror/static-1.10908",
  "react-colorpicker": "/react-colorpicker/static-2.10477",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8372",
  "rich-text-lib": "/rich-text-lib/static-1.20266",
  "tinymce-data": "/tinymce-data/static-1.41134",
  "tinymce-themes": "/tinymce-themes/static-1.57019",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10155",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5482",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16354",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10567",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10565",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5311",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1238",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.344",
  "chirp-fetch": "/chirp-fetch/static-1.2163",
  "chatspot-core": "/chatspot-core/static-1.22807",
  "copilot-toolkit": "/copilot-toolkit/static-1.11796",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13300",
  "data-fetching-client": "/data-fetching-client/static-1.9927",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5026",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8971",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29255",
  "usage-tracker": "/usage-tracker/static-1.7625",
  "cms-field-types": "/cms-field-types/static-1.5084",
  "content-icons-ui": "/content-icons-ui/static-1.2332",
  "integrations-lib": "/integrations-lib/static-1.16976",
  "customer-data-objects": "/customer-data-objects/static-1.7958",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1642",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4925",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4419",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9346",
  "video-components-external": "/video-components-external/static-1.12102",
  "video-data-lib": "/video-data-lib/static-1.35760",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.252",
  "audio-components": "/audio-components/static-1.6301",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29768",
  "FileManagerImages": "/FileManagerImages/static-1.37573",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1467",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.532",
  "ui-universal-auth": "/ui-universal-auth/static-1.9343",
  "urlinator": "/urlinator/static-1.4802",
  "video-components": "/video-components/static-1.14104",
  "video-embed": "/video-embed/static-1.36594",
  "ts-schema": "/ts-schema/static-1.4272",
  "ContentData": "/ContentData/static-1.69146",
  "layout-data-lib": "/layout-data-lib/static-1.10222",
  "react-dnd-compat": "/react-dnd-compat/static-1.4886",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1812",
  "external-options-client-types": "/external-options-client-types/static-1.4318",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7161",
  "hs-promise-utils": "/hs-promise-utils/static-1.5866",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4035",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9241",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3331",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11415",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5735",
  "magpie-types": "/magpie-types/static-1.5195",
  "simple-logging-lib": "/simple-logging-lib/static-1.3320",
  "avatar-components": "/avatar-components/static-1.2763",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10098",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6852",
  "flux-actions": "/flux-actions/static-1.365",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5148",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14391",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5877",
  "laboratory-lib": "/laboratory-lib/static-3.7420",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8048",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10536",
  "unified-auth": "/unified-auth/static-1.857",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.620",
  "breeze-engine-core": "/breeze-engine-core/static-1.920",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8091",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13179",
  "content-media-compositions": "/content-media-compositions/static-2.17186",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19366",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1139",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15537",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12415",
  "ExportDialog": "/ExportDialog/static-6.10648",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34788",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3989",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4326",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.280",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4200",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7066",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3887",
  "persist-promise": "/persist-promise/static-1.3969",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5925",
  "reactive-lib": "/reactive-lib/static-1.989",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.607",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3277",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.409",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1207",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.976",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.74",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.420",
  "slack-ui-library": "/slack-ui-library/static-1.10667",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4017",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15536",
  "simple-menus-lib": "/simple-menus-lib/static-1.17053",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3763",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10043",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
